import { render, staticRenderFns } from "./EditorColorPicker.vue?vue&type=template&id=a426cabc&scoped=true&"
import script from "./EditorColorPicker.vue?vue&type=script&lang=js&"
export * from "./EditorColorPicker.vue?vue&type=script&lang=js&"
import style0 from "./EditorColorPicker.vue?vue&type=style&index=0&id=a426cabc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a426cabc",
  null
  
)

export default component.exports